<div
  *ngIf="isLoading"
  class="spinner-border text-primary landingspinner"
  style="width: 5rem; height: 5rem"
  role="status">
  <span class="sr-only">Loading...</span>
</div>
<div class="container py-3" *ngIf="!isLoading">
  DASHBOARD
</div>
